export const customSelect = {
    control: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        borderRadius: '5px',
        border: '1px solid #EDEFF3',
        boxShadow: 'none',
        backgroundColor: '#FFF',
        fontStyle: '"Lexend", sans-serif',
        fontSize: '13px',
        fontWeight: '400',
        color: state.isDisabled ? '#ccc' : '#33353E',
        width: '100%',
        maxWidth: '100%',
        paddingRight: '10px',
        paddingLeft: '5px',
        '&:hover': {
            border: '1px solid #EDEFF3',
        },
    }),
    container: (provided) => ({
        ...provided,
        width: '100%'
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? '#888' : '#000',
        maxWidth: '90%'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        display: 'none',
        padding: '2px',
        position: 'absolute',
        right: '5px',
        color: '#888',
        '& svg': {
            width: '15px',
            height: '15px',
            '&:hover': {
                color: '#000',
            }
        }
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none'
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: '8px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontSize: '0.8rem',
        color: '#888',
        fontFamily: '"Lexend", sans-serif',
        textAlign: 'left',
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: '0.8rem',
        fontWeight: '400',
        background: state.isSelected ? '#f0f0f0' : '#FFF',
        color: '#33353E',
        '&:hover': {backgroundColor: '#f0f0f0'}
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? '#888' : '#33353E',
        fontSize: '13px',
        fontFamily: '"Lexend", sans-serif'
    }),
    clearIndicator: (provided) => ({
        ...provided,
        position: 'absolute',
        cursor: 'pointer',
        right: '0',
        '& svg': {
            width: '16px',
            height: '16px',
            color: '#888',
            '&:hover': {
                color: '#000',
            }
        }
    }),
    multiValue: (provided, props) => {
        const isUnavailable = props?.data?.value?.available === false;

        return {
            ...provided,
            background: isUnavailable ? '#FFE7E7' : '#F5EDFF',
            color: isUnavailable ? '#D80303' : '#8540DD',
            maxWidth: '200px'
        };
    },
    multiValueRemove: (provided, props) => {
        const isUnavailable = props?.data?.value?.available === false;

        return {
            ...provided,
            color: '#8540DD',
            '&:hover': {
                background: isUnavailable ? '#FFE7E7' : '#F5EDFF',
                color: isUnavailable ? '#D80303' : '#8540DD'
            }
        }
    },
    multiValueLabel: (provided, props) => {
        const isUnavailable = props?.data?.value?.available === false;

        return {
            ...provided,
            color: isUnavailable ? '#D80303' : '#8540DD',
            maxWidth: '200px'
        }
    }
}

export const createFirstRestaurantSelect = {
    ...customSelect,
    control: (provided, state) => ({
        ...customSelect.control(provided, state),
        borderRadius: '10px',
        border: 'none',
        background: '#F9F9F9',
        '&:hover': {
            border: 'none',
        },
    }),
    singleValue: (provided, state) => ({
        ...customSelect.singleValue(provided, state),
        color: '#6E6E73',
        fontSize: '0.9rem',
        fontWeight: '300'
    }),
    menuList: (provided) => ({
        ...provided,
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        borderRadius: '10px',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
    }),
}

export const mainSelect = {
    control: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        borderRadius: '22px',
        border: '1px solid #EDEFF3',
        boxSizing: 'border-box',
        backgroundColor: '#FFF',
        fontStyle: '"Lexend", sans-serif',
        fontSize: '1rem',
        fontWeight: '400',
        color: state.isDisabled ? '#ccc' : '#191D25',
        width: 'fit-content',
        minWidth: '130px',
        maxWidth: '600px',
        height: '32px',
        minHeight: '32px',
        textAlign: 'left',
        paddingLeft: '5px',
        paddingRight: '15px',
        borderColor: state.isFocused ? 'transparent' : provided.borderColor,
        boxShadow: state.isFocused ? 'none' : provided.boxShadow,
        '&:hover': {
            borderColor: state.isFocused ? 'transparent' : provided['&:hover'].borderColor,
            border: '1px solid #EDEFF3'
        }
    }),
    valueContainer: provided => ({
        ...provided,
        overflow: 'visible'
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? '#888' : '#191D25',
        maxWidth: '100%'
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        display: state.isDisabled ? 'none' : provided.display,
        padding: '8px',
        position: 'absolute',
        right: '5px',
        color: '#3E424C',
        '& svg': {
            width: '15px',
            height: '15px',
            '&:hover': {
                color: '#000',
            }
        }
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none'
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        padding: '5px'
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: '5px',
        minHeight: '32px',
        width: '100%',
        zIndex: 900,
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontSize: '1rem',
        color: '#888',
        fontWeight: '400',
        fontFamily: '"Lexend", sans-serif',
        textAlign: 'left'
    }),
    option: (provided) => ({
        ...provided,
        fontSize: '1rem',
        fontWeight: '400',
        background: null,
        backgroundColor: null,
        color: '#191D25',

        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textWrap: 'wrap',
        '&:hover': {backgroundColor: '#F0F0F0'}
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? '#888' : '#3E424C',
        fontSize: '1rem',
        fontFamily: '"Lexend", sans-serif',
        fontWeight: '300',
    }),
    clearIndicator: (provided) => ({
        ...provided,
        position: 'absolute',
        cursor: 'pointer',
        right: '25px',
        '& svg': {
            width: '16px',
            height: '16px',
            color: '#888',
            '&:hover': {
                color: '#000',
            }
        }
    })
}

export const mainSelectTopper = {
    ...mainSelect,
    menu: provided => ({
        ...mainSelect.menu(provided),
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px'
    }),
}

export const mainSelectMenuTopper = {
    ...mainSelectTopper,
    singleValue: (provided) => ({
        ...provided,
        color: '#191D25',
        display: 'flex',
        alignItems: 'center',
        padding: '0 10px 0 0'
    }),
    control: (provided, state) => ({
        ...mainSelectTopper.control(provided, state),
        paddingRight: '10px'
    })
}

export const menuPickerSelect = {
    ...mainSelectMenuTopper,
    control: (provided, state) => ({
        ...mainSelectMenuTopper.control(provided, state),
        width: '100%'
    })
}

export const mainSelectTime = {
    ...mainSelect,
    control: (provided, state) => ({
        ...mainSelect.control(provided, state),
        width: '100px'
    })
}

export const mainSelectWhite = {
    ...mainSelect,
    control: (provided, state) => ({
        ...mainSelect.control(provided, state),
        backgroundColor: '#FFF'
    }),
    singleValue: provided => ({
        ...provided,
        maxWidth: '100%'
    }),
}

export const dateStyles = {
    ...mainSelect,
    control: (provided, state) => ({
        ...mainSelect.control(provided, state),
        minWidth: '20px'
    }),
    menu: (provided, state) => ({
        ...mainSelect.menu(provided, state),
        maxWidth: 'fit-content',
        minWidth: '100%',
        width:'unset'
    })
}

export const timeStyles = {
    ...dateStyles,
    control: (provided, state) => ({
        ...dateStyles.control(provided, state),
        paddingRight: '0',
        paddingLeft: '0',
        minWidth: 'unset',
        maxWidth: 'unset',
        width: '56px',
        height: '30px',
        minHeight: '30px'
    }),
    menu: (provided, state) => ({
        ...dateStyles.menu(provided, state),
        maxWidth: 'unset',
        minWidth: 'unset',
        width: '100%',
        padding: '0'
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: 150,
        overflowY: 'auto',
        overflowX: 'hidden',
        padding: 0
    }),
    option: (provided, state) => ({
        ...dateStyles.option(provided, state),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 0'
    }),
    dropdownIndicator: (provided, state) => ({
        ...dateStyles.dropdownIndicator(provided, state),
        display: 'none'
    }),
    indicatorsContainer: (provided, state) => ({
        ...dateStyles.indicatorsContainer(provided, state),
        display: 'none'
    })
}

export const chartStyles = {
    ...mainSelect,
    control: (provided, state) => ({
        ...mainSelect.control(provided, state),
        minWidth: '100px',
        maxWidth: '180px',
        paddingRight: '15px'
    }),
    menu: (provided, state) => ({
        ...mainSelect.menu(provided, state),
        maxWidth: '140px',
        minWidth: '100%',
        width:'unset'
    }),
    menuList: (provided) => ({
        ...provided,
        textAlign: 'left',
    })
}

export const languageStyles = {
    ...mainSelect,
    control: (provided, state) => ({
        ...mainSelect.control(provided, state),
        paddingLeft: '0',
        paddingRight: '0',
        width: '100%',
        minWidth: '0',
        maxWidth: '100%',
        color: '#93939E',
        backgroundColor: 'transparent',
        border: 'none',
        '&:hover': {
            border: 'none'
        }
    }),
    valueContainer: (provided, state) => ({
        ...mainSelect.valueContainer(provided, state),
        padding: '0'
    }),
    singleValue: (provided, state) => ({
        ...mainSelect.singleValue(provided, state),
        margin: '0',
        color: '#93939E',
        '&:hover': {
            color: '#FFF',
        },
        '& svg': {
            color: '#93939E',
            '&:hover': {
                color: '#FFF',
            }
        }
    }),
    dropdownIndicator: (provided, state) => ({
        ...mainSelect.dropdownIndicator(provided, state),
        '& svg': {
            width: '16px',
            height: '16px',
            color: '#93939E',
            '&:hover': {
                color: '#FFF',
            }
        }
    }),
    menu: (provided, state) => ({
        ...mainSelect.menu(provided, state),
        backgroundColor: '#191D25',
        width: 'calc(100% - 20px)',
        marginLeft: 0
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
        color: '#93939E',
        cursor: 'pointer',
        ...(state.isFocused && {
            backgroundColor: 'transparent'
        }),
        ...(state.isSelected && {
            backgroundColor: 'transparent'
        }),
        ':active': {
            backgroundColor: 'transparent'
        },
        '&:hover': {
            color: '#FFF'
        }
    })
}

export const languageStylesMobile = {
    ...languageStyles,
    dropdownIndicator: (provided, state) => ({
        ...languageStyles.dropdownIndicator(provided, state),
        '& svg': {
            display: 'none'
        }
    }),
    indicatorsContainer: (provided, state) => ({
        ...languageStyles.indicatorsContainer(provided, state),
        display: 'none'
    }),
    menu: (provided, state) => ({
        ...languageStyles.menu(provided, state),
        width: '35px',
        transform: 'translateX(-7px)'
    }),
    option: (provided, state) => ({
        ...languageStyles.option(provided, state),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    })
}

export const languageStylesMainPage = {
    ...mainSelect,
    control: (provided, state) => ({
        ...mainSelect.control(provided, state),
        border: 'none',
        borderColor: 'transparent',
        boxShadow: 'none',
        '&:hover': {
            borderColor: 'transparent',
            border: 'none'
        }
    }),
    dropdownIndicator: (provided, state) => ({
        ...mainSelect.dropdownIndicator(provided, state),
        color: '#3E424C',
        '& svg': {
            width: '15px',
            height: '15px',
            '&:hover': {
                color: '#3E424C',
            }
        }
    }),
    indicatorsContainer: (provided, state) => ({
        ...languageStyles.indicatorsContainer(provided, state),
        '&:hover': {
            color: '#3E424C',
        }
    })
}

export const languageStylesMainPageMobile = {
    ...languageStylesMainPage,
    menu: (provided, state) => ({
        ...languageStylesMainPage.menu(provided, state),
        minWidth: '0',
        width: '35px',
        transform: 'translateX(2px)'
    }),
    dropdownIndicator: (provided, state) => ({
        ...languageStylesMainPage.dropdownIndicator(provided, state),
        '& svg': {
            display: 'none'
        }
    }),
    indicatorsContainer: (provided, state) => ({
        ...languageStylesMainPage.indicatorsContainer(provided, state),
        display: 'none'
    }),
    option: (provided, state) => ({
        ...languageStylesMainPage.option(provided, state),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }),
    control: (provided, state) => ({
        ...languageStylesMainPage.control(provided, state),
        border: 'none',
        width: 'fit-content',
        minWidth: 'unset',
        paddingLeft: 'unset',
        paddingRight: 'unset',
        borderColor: state.isFocused ? 'transparent' : provided.borderColor,
        boxShadow: state.isFocused ? 'none' : provided.boxShadow,
        '&:hover': {
            borderColor: state.isFocused ? 'transparent' : provided['&:hover'].borderColor,
            border: '1px solid #EDEFF3'
        }
    })
}